<template>
  <form>
    <br />
    <center>
      <h1 class="title">Question {{ startStep }}</h1>
    </center>
    <br />
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <b-progress size="is-small" type="is-primary" :value="progressValue" />
      </div>
    </div>
    <center>
      <h6 class="subtitle is-6">
        <strong
          ><span
            v-html="$t('compCarbonFormsSurveyOkToAnswerFoodForm.question-1')"
        /></strong>
      </h6>
    </center>
    <br />
    <div>
      <div class="columns">
        <div class="column is-3 is-offset-3">
          <b-button
            expanded
            @click="$emit('input', true)"
            :type="buffer ? 'is-primary is-light' : ''"
          >
            {{ $t('yes') }}
          </b-button>
        </div>
        <div class="column is-3">
          <b-button
            expanded
            @click="$emit('input', false)"
            :type="!buffer ? 'is-primary is-light' : ''"
          >
            {{ $t('no') }}
          </b-button>
        </div>
      </div>
      <br />
    </div>
    <div class="columns">
      <div class="column">
        <b-button
          class="button is-fullwidth"
          @click="$emit('back')"
          icon-left="angle-double-left"
        >
          {{ $t('previous') }}
        </b-button>
      </div>
      <div class="column">
        <b-button
          class="button is-fullwidth is-primary"
          @click="$emit('submit')"
          icon-right="angle-double-right"
        >
          {{ nextBtnLabel }}
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'OkToAnswerFoodForm',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    totalStep: {
      type: Number,
      default: 0
    },
    startStep: {
      type: Number,
      default: 0
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      buffer: this.value
    }
  },
  computed: {
    progressValue: function () {
      return (this.startStep / this.totalStep) * 100
    },
    nextBtnLabel: function () {
      if (this.progressValue === 100) {
        return this.$t('preview')
      } else {
        return this.$t('next')
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = this.value
      },
      deep: true
    }
  }
}
</script>
